import React, { useState, useEffect } from "react";
import {
  CardContent,
  RadioGroup,
  Box,
  FormControlLabel,
  Radio,
  Typography,
  Stack,
} from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import commonMessages from "../../utility/constant";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import { getAuthToken } from "../../utility/tokenUtility";
import axios from "axios";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import { useNavigate } from "react-router-dom";

function WorkOrderStatus() {
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState("schedule");
  const [counts, setCounts] = useState({});
  const allMonths = commonMessages.months;
  const all = { label: "All", value: "All", id: "0" };
  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth();

  const [year, setYear] = useState({ label: currentYear.toString(), value: currentYear.toString() });
  const [month, setMonth] = useState(allMonths[currentMonthIndex]);
  const [monthsOptions, setMonthsOptions] = useState([]);
  const [yearsOptions, setYearsOptions] = useState([]);

  const fetchMaintenanceYears = async () => {
    const facilityid = localStorage.getItem("facilityId");
    try {
      const response = await axios.get(`${MasterGraph}/api/GraphMaintenanceYear/GetMaintenanceYearByFacilityId/${facilityid}?page=1&size=100`);
      const years = response.data.items.map(y => ({ label: y.maintyearvalue.toString(), value: y.maintyearvalue.toString() }));
      setYearsOptions(years);
    } catch (error) {
      console.error("Error fetching maintenance years:", error);
    }
  };

  const fetchTotalCount = async () => {
    try {
      const facilityid = localStorage.getItem("facilityId");
      const token = getAuthToken("id_token");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const [resFEMS, resBEMS] = await Promise.all([
        axios.get(`${FemsGraph}/api/FEMSDashboardWidgets/GetDashboardCountByFacilityIdWOStatusCount/${facilityid}/${month?.id}/${year?.value}`, config),
        axios.get(`${BemsGraph}/api/BEMSDashboardWidgets/GetDashboardCountByFacilityIdWOStatusCount/${facilityid}/${month?.id}/${year?.value}`, config),
      ]);

      const fems = resFEMS.data || {};
      const bems = resBEMS.data || {};

      const combinedCounts = {
        scheduledClosed: (fems.scheduledClosedCount || 0) + (bems.scheduledClosedCount || 0),
        scheduledOpen: (fems.scheduledOpenCount || 0) + (bems.scheduledOpenCount || 0),
        scheduledInProgress: (fems.scheduledInprogressCount || 0) + (bems.scheduledInprogressCount || 0),
        scheduledCompleted: (fems.scheduledCompletedCount || 0) + (bems.scheduledCompletedCount || 0),
        unscheduledClosed: (fems.unscheduledClosedCount || 0) + (bems.unscheduledClosedCount || 0),
        unscheduledOpen: (fems.unscheduledOpenCount || 0) + (bems.unscheduledOpenCount || 0),
        unscheduledInProgress: (fems.unscheduledInprogressCount || 0) + (bems.unscheduledInprogressCount || 0),
        unscheduledCompleted: (fems.unscheduledCompletedCount || 0) + (bems.unscheduledCompletedCount || 0),
      };

      setCounts(combinedCounts);

    } catch (error) {
      console.error("Error fetching work order counts:", error);
    }
  };
  useEffect(() => {
    const selectedYear = parseInt(year.value);
    const isNextYear = currentMonthIndex === 11;

    const months =
      selectedYear === currentYear
        ? [
          all,
          ...allMonths.slice(0, currentMonthIndex + 1), // Up to the current month
          // ...(isNextYear ? [] : [allMonths[(currentMonthIndex + 1) % 12]]), // Include next month
        ]
        : [all, ...allMonths]; // All months for previous years

    setMonthsOptions(months);

    // if (!location?.state?.month) {

    setMonth(
      selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]
    );
    // }
  }, [year]);

  useEffect(() => {
    fetchMaintenanceYears();
    fetchTotalCount();
  }, [year, month]);

  const handleYearChange = (newValue) => {
    setYear(newValue);
  };

  const handleMonthChange = (newValue) => {
    setMonth(newValue);
  };

  const chartData = selectedValue === "schedule" ? [
    { status: "New", count: counts.scheduledOpen || 0 },
    { status: "In Progress", count: counts.scheduledInProgress || 0 },
    { status: "Completed", count: counts.scheduledCompleted || 0 },
    { status: "Closed", count: counts.scheduledClosed || 0 },
  ] : [
    { status: "New", count: counts.unscheduledOpen || 0 },
    { status: "In Progress", count: counts.unscheduledInProgress || 0 },
    { status: "Completed", count: counts.unscheduledCompleted || 0 },
    { status: "Closed", count: counts.unscheduledClosed || 0 },
  ];

  return (
    <StyledCard variant="outlined">
      <CardContent>

        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
          <Typography variant="h5" fontWeight={700} color="text.primary">
            W.O Status by Month
          </Typography>

          <Stack direction="row" alignItems="center" gap={1}>
            <CustomSelectInput
              fullWidth={false}
              labelSize="14px"
              sx={{ width: 100 }}
              label="Year"
              options={yearsOptions}
              value={year}
              onChange={handleYearChange}
              placeholder="Select Year"
              disableClearable
              highlight
            />
            <CustomSelectInput
              fullWidth={false}
              labelSize="14px"
              sx={{ width: 100 }}
              label="Month"
              options={monthsOptions}
              value={month}
              onChange={handleMonthChange}
              placeholder="Select Month"
              disableClearable
              highlight
            />
          </Stack>
        </Stack>

        <Box>
          <RadioGroup
            row
            value={selectedValue}
            onChange={(e) => setSelectedValue(e.target.value)}
          >
            <FormControlLabel value="schedule" control={<Radio size="small" />} label="Schedule" />
            <FormControlLabel value="unschedule" control={<Radio size="small" />} label="Unschedule" />
          </RadioGroup>
        </Box>

        <Box width="100%" height={300}>
          <BarChart
            dataset={chartData}
            xAxis={[{
              label: "Status",
              dataKey: "status",
              scaleType: "band",
              labelStyle: {
                transform: "translateY(20px)",
              },
              tickLabelStyle: {
                textAnchor: "middle",
                dominantBaseline: "hanging",
                fontSize: 12,
              },
            }]}
            yAxis={[{
              label: "Count",
              labelStyle:{
              transform: "rotate(-90deg) translate(-120px, -200px)",
              textAnchor: "middle",
              }

            }]}
            series={[{ dataKey: "count", label:"Count", color: "#62B5DD" }]}
            onItemClick={(event, item) => navigate("/workorder", { state: { year: year?.value, month: { value: month?.value, label: month?.label, id: month?.id } } })}
            margin={{ left: 80, bottom: 60 }}
            slotProps={{ legend: { hidden: true } }}
          />
        </Box>

      </CardContent>
    </StyledCard>
  );
}

export default WorkOrderStatus;
